export default "__VITE_ASSET__CBgCw3hT__"